import { Component } from '@angular/core';
import { Storage } from '@ionic/storage';
import { NavController, ToastController } from 'ionic-angular';
import { HomePage } from '../home/home';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';

@Component({
    selector: 'page-welcome',
    templateUrl: './welcome.html'
})
export class WelcomePage {
    public formLogin: FormGroup;
    public usuario: { NomeUsuario: string, Senha: string } = { NomeUsuario: '', Senha: '' }

    constructor(
        private _storage: Storage,
        private _navCtrl: NavController,
        private _toastCtrl: ToastController,
        _formBuilder: FormBuilder
    ) {
        _storage.get('manter').then(b => {
            let mantido = b != null ? b : false;
            if (mantido) this._navCtrl.setRoot(HomePage);
        }, e => console.error(e));

        this.formLogin = _formBuilder.group({
            Usuario: ['', Validators.compose([Validators.required, Validators.minLength(4), Validators.pattern(/^[a-z][a-z0-9]*[._-]?[a-z0-9]+$/)])],
            Senha: ['', Validators.compose([Validators.required, Validators.minLength(4)])],
            MantenhaConectado: [true]
        });
    }

    public views(): void {
        if (this.usuario.NomeUsuario == 'diretoria' && this.usuario.Senha == '1234') {
            if (this.formLogin.controls['MantenhaConectado'].value)
                this._storage.set('manter', true);

            this._navCtrl.setRoot(HomePage);
            return;
        }

        this._toastCtrl.create({ message: 'Usuário ou senha incorretos.', position: 'top', duration: 3000 }).present();
    }
}



// WEBPACK FOOTER //
// ./src/pages/welcome/welcome.ts